import "./styles.css";
import { useContext, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDrawerContext } from "context/DrawerContext";
import useClickOutside from "utils/clickOutside";
import { AuthContext } from "context/AuthContext";
import logo from "assets/logo.png";
import { BsBuildings } from "react-icons/bs";
import { BsPeople } from "react-icons/bs";
import { BsGear } from "react-icons/bs";
import { BsPieChart } from "react-icons/bs";
import { BsLayoutTextWindowReverse } from "react-icons/bs";
import { BsArrowDownShort } from "react-icons/bs";
import { DocumentsSVG } from "assets/svgs/DocumentsSVG";
import { GiftSVG } from "assets/svgs/GiftSVG";
import { CubesSVG } from "assets/svgs/CubesSVG";

const determineActiveSection = (location) => {
  const segments = location.pathname.split("/");
  const companyDrop = ['companies/dashboard','companies', 'departments'];
  const hrDrop = ['hr/dashboard','employees', 'employees-salaries', 'employees-increments', 'employees-leaves', 'employees-bonuses', 'employees-complaints', 'employees-attendances', 'paycheque-calculator', 'leave-rules'];
  const taskManagementDrop = ['task/dashboard','employeestasks', 'events', 'calendar', 'public-holidays'];
  const projectDrop = ['projects', 'projectscategories', 'demands', 'quotations', 'purchaseorders', 'paymentvouchers', 'vendors', 'comparequotations'];
  const stockManagementDrop = ['stockitems', 'materialissues', 'materialreceiptslips', 'stockcategories'];
  const reportsDrop = ['employee-report'];
  const settingsDrop = ['working-hours', 'roles', 'admins'];
  const myDocumentsDrop = ['mytasks', 'my-complaints', 'my-leaves', 'my-attendance', 'my-meetings'];
  const myAccountsDrop = ['accounts', ];

  for (let i = 0; i < companyDrop.length; i++) {
    if (segments.includes(companyDrop[i])) {
      return "companyDrop";
    }
  }

  for (let i = 0; i < hrDrop.length; i++) {
    if (segments.includes(hrDrop[i])) {
      return "hrDrop";
    }
  }

  for (let i = 0; i < taskManagementDrop.length; i++) {
    if (segments.includes(taskManagementDrop[i])) {
      return "taskManagementDrop";
    }
  }

  for (let i = 0; i < projectDrop.length; i++) {
    if (segments.includes(projectDrop[i])) {
      return "projectDrop";
    }
  }

  for (let i = 0; i < stockManagementDrop.length; i++) {
    if (segments.includes(stockManagementDrop[i])) {
      return "stockManagementDrop";
    }
  }

  for (let i = 0; i < reportsDrop.length; i++) {
    if (segments.includes(reportsDrop[i])) {
      return "reportsDrop";
    }
  }

  for (let i = 0; i < settingsDrop.length; i++) {
    if (segments.includes(settingsDrop[i])) {
      return "settingsDrop";
    }
  }

  for (let i = 0; i < myDocumentsDrop.length; i++) {
    if (segments.includes(myDocumentsDrop[i])) {
      return "myDocumentsDrop";
    }
  }
  for (let i = 0; i < myAccountsDrop.length; i++) {
    if (segments.includes(myAccountsDrop[i])) {
      return "accountsDrop";
    }
  }

  return null;

}

const Sidebar = () => {
  const sidebarRef = useRef();
  const location = useLocation();
  const activeSection = determineActiveSection(location);

  const [showCompanyDrop, setShowCompanyDrop] = useState(activeSection === "companyDrop");
  const [showHRDrop, setShowHRDrop] = useState(activeSection === "hrDrop");
  const [showTaskManagementDrop, setShowTaskManagementDrop] = useState(activeSection === "taskManagementDrop");
  const [showProjectManagementDrop, setShowProjectManagementDrop] = useState(activeSection === "projectDrop");
  const [showStockManagementDrop, setShowStockManagementDrop] = useState(activeSection === "stockManagementDrop");
  const [showReportsDrop, setShowReportsDrop] = useState(activeSection === "reportsDrop");
  const [showAccountsDrop, setShowAccountsDrop] = useState(activeSection === "accountsDrop");
  const [showSettingsDrop, setShowSettingsDrop] = useState(activeSection === "settingsDrop");
  const [showMyDocumentsDrop, setShowMyDocumentsDrop] = useState(activeSection === "myDocumentsDrop");
  const { showDrawer, setShowDrawer } = useDrawerContext();
  const { userData, removeUserData } = useContext(AuthContext);
  const navigate = useNavigate();
  useClickOutside(sidebarRef, () => setShowDrawer(false));

  function handleLogOutButton(event) {
    removeUserData();
    navigate("/dashboard");
  }

  const isActive = (path, home) => { //not needed as NavLink component does the same thing
    if (home) {
      return (location.pathname === "/" || location.pathname === "/dashboard");
    }
    else {
      return location.pathname.split("/").includes(path);
    }
  };

  console.log("Before Sidebar() rendering");
  console.log(userData.doc);
  console.log(userData.role);

  return (
    <aside>
      {
        showDrawer && (
          <div
            className="fixed top-0 left-0 bg-gray-900 w-full h-screen bg-opacity-30 opacity-1 duration-300 z-10"
          >
          </div>
        )
      }
      <div
        className={`sidebar ${showDrawer ? "show" : ""
          } fixed top-0 xl:left-0 -left-[200%] w-[250px] min-h-screen h-full overflow-auto py-4 z-50 border-r bg-pure flex flex-col justify-between`
        }
        ref={sidebarRef}
      >

        <div className="">

          <div className="flex justify-center">
            <NavLink to="/" className="text-3xl font-bold text-primary">
              <img className=" h-10" src={logo} alt="technoproperties" />
            </NavLink>
          </div>

          <div className="mt-2">
            <NavLink
              to="/dashboard"
              className={`sideMenu-heading flex items-center gap-x-2 ${isActive('dashboard') ? 'sideMenuActiveSection' : ''}`}
            >
              <BsLayoutTextWindowReverse />
              <span>Dashboard</span>
            </NavLink>
          </div>

          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'companyDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowCompanyDrop(prev => !prev)}
              >
                <div>
                  <BsBuildings />
                </div>
                <div>
                  Company Management
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            (showCompanyDrop) && (
              <ul className="sideMenu-dropList">
                <li>
                  <NavLink
                    to="/companies/dashboard"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    Dashboard
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/companies"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    All Companies
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/departments"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    All Departments
                  </NavLink>
                </li>
              </ul>
            )
          }

          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.create.includes("employees") ||
              userData.role.read.includes("employeeincrements") ||
              userData.role.read.includes("employeeleaves") ||
              userData.role.read.includes("employeebonuses") ||
              userData.role.read.includes("employeecomplaints") ||
              userData.role.read.includes("employeeattendances") ||
              userData.role.read.includes("leaverules")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'hrDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowHRDrop(prev => !prev)}
              >
                <div>
                  <BsPeople />
                </div>
                <div>
                  HR Management
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            (showHRDrop) && (
              
              <ul className="sideMenu-dropList">

                  <li>
                  <NavLink
                    to="/hr/dashboard"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    Dashboard
                  </NavLink>
                </li>
                {
                  
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.create.includes("employees")
                  ) && (
                    <li>
                      <NavLink
                        to="/employees"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        All Employees
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.create.includes("employees")
                  ) && (
                    <li>
                      <NavLink
                        to="/employees-salaries"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Employees Salaries
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeeincrements")
                  ) && (
                    <li>
                      <NavLink
                        to="/employees-increments"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Employees Increments
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeeleaves")
                  ) && (
                    <li>
                      <NavLink to="/employees-leaves" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Employees Leaves
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeebonuses")
                  ) && (
                    <li>
                      <NavLink to="/employees-bonuses" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Employees Bonuses
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeecomplaints")
                  ) && (
                    <li>
                      <NavLink to="/employees-complaints" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Employees Complaints
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeeattendances")
                  ) && (
                    <li>
                      <NavLink to="/employees-attendances" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Employees Attendances
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.create.includes("employees") ||
                    userData.role.create.includes("employeeincrements")
                  ) && (
                    <li>
                      <NavLink to="/paycheque-calculator" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Pay Cheque Calculator
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("leaverules")
                  ) && (
                    <li>
                      <NavLink to="/leave-rules" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Leave Rules
                      </NavLink>
                    </li>
                  )
                }

              </ul>
            )
          }

          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("employeetasks") ||
              userData.role.read.includes("events") ||
              userData.role.read.includes("publicholidays")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'taskManagementDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowTaskManagementDrop(prev => !prev)}
              >
                <div>
                  <GiftSVG width={16} height={16} />
                </div>
                <div>
                  Task Management
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showTaskManagementDrop && (
              <ul className="sideMenu-dropList">
                <li>
                  <NavLink
                    to="/task/dashboard"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    Dashboard
                  </NavLink>
                </li>
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employeetasks")
                  )
                  && (
                    <li>

                      <NavLink to="/employeestasks" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Employees Tasks
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("events")
                  )
                  && (
                    <li>
                      <NavLink to="/events" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Meetings / Events
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("events")
                  )
                  && (
                    <li>
                      <NavLink to="/calendar" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Calendar
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("publicholidays")
                  )
                  && (
                    <li>
                      <NavLink to="/public-holidays" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Public Holidays
                      </NavLink>
                    </li>
                  )
                }
              </ul>
            )
          }

          {
            (
              userData.role?.read.includes("mytasks") ||
              userData.role?.read.includes("myleaves") ||
              userData.role?.read.includes("mycomplaints")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'myDocumentsDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowMyDocumentsDrop(prev => !prev)}
              >
                <div>
                  <DocumentsSVG width={16} height={16} />
                </div>
                <div>
                  My Documents
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showMyDocumentsDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.role?.read.includes("mytasks")
                  ) && (
                    <li>
                      <NavLink
                        to="/mytasks"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        My Tasks
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.role?.read.includes("myleaves")
                  )
                  && (
                    <li>
                      <NavLink to="/my-leaves" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        My Leaves
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.role?.read.includes("mycomplaints")
                  )
                  && (
                    <li>
                      <NavLink to="/my-complaints" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        My Complaints
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.role?.read.includes("myattendances")
                  )
                  && (
                    <li>
                      <NavLink to="/my-attendance" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        My Attendance
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.role?.read.includes("mymeetings")
                  )
                  && (
                    <li>
                      <NavLink to="/my-meetings" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        My Meetings
                      </NavLink>
                    </li>
                  )
                }


              </ul>
            )
          }

          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("projects") ||
              userData.role.read.includes("projectscategories") ||
              userData.role.read.includes("demands") ||
              userData.role.read.includes("quotations") ||
              userData.role.read.includes("purchaseorders") ||
              userData.role.read.includes("paymentvouchers") ||
              userData.role.read.includes("vendors")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'projectDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowProjectManagementDrop(prev => !prev)}
              >
                <div>
                  <CubesSVG />
                </div>
                <div>
                  Project Management
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showProjectManagementDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("projects")
                  ) && (
                   
                    <li>
                    <NavLink
                      to="/projects/dashboard"
                      className="sideMenu-item"
                    >
                      <div className="sideMenu-dropCircle"></div>
                      Dashboard
                    </NavLink>
                  </li>
                  )
                }
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("projects")
                  ) && (
                   
                   <li>
                      <NavLink
                        to="/projects"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Projects
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("projectcategories")
                  )
                  && (
                    <li>
                      <NavLink to="/projectscategories" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Project Categories
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("demands")
                  )
                  && (
                    <li>
                      <NavLink to="/demands" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Demands
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("quotations")
                  )
                  && (
                    <li>
                      <NavLink to="/quotations" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Quotations
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("purchaseorders")
                  )
                  && (
                    <li>
                      <NavLink to="/purchaseorders" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Purchase Orders
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("paymentvouchers")
                  )
                  && (
                    <li>
                      <NavLink to="/paymentvouchers" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Payment Vouchers
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("vendors")
                  )
                  && (
                    <li>
                      <NavLink to="/vendors" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Vendors
                      </NavLink>
                    </li>
                  )
                }
              </ul>
            )
          }


          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("stockitems") ||
              userData.role.read.includes("materialissues") ||
              userData.role.read.includes("materialreceiptslips") ||
              userData.role.read.includes("stockcategories")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'stockManagementDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowStockManagementDrop(prev => !prev)}
              >
                <div>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1_51)">
                      <path d="M9.9001 14.9999H5.4001L3.50009 13.0999C2.80008 12.3999 1.70009 12.3999 1.10009 13.0999C0.80009 13.3999 0.600098 13.8999 0.600098 14.2999C0.600098 14.6999 0.80009 15.1999 1.10009 15.4999L3.50009 17.8999C3.80009 18.1999 4.30008 18.3999 4.70009 18.3999H8.20008V22.6999C8.20008 22.9999 8.40007 23.1999 8.70007 23.1999C9.00007 23.1999 9.20007 22.9999 9.20007 22.6999V17.8999C9.20007 17.5999 9.00007 17.3999 8.70007 17.3999H4.70007C4.60006 17.3999 4.30006 17.2999 4.20007 17.1999L1.80007 14.7999C1.70007 14.6999 1.60008 14.4999 1.60008 14.2999C1.60008 14.0999 1.70009 13.8999 1.80007 13.7999C2.10007 13.4999 2.50008 13.4999 2.80008 13.7999L4.80007 15.7999C4.90008 15.8999 5.00007 15.9999 5.10007 15.9999H9.80007C10.2001 15.9999 10.5001 16.2999 10.5001 16.6999V22.6999C10.5001 22.9999 10.7001 23.1999 11.0001 23.1999C11.3001 23.1999 11.5001 22.9999 11.5001 22.6999V16.6999C11.6001 15.6999 10.8001 14.9999 9.90005 14.9999L9.9001 14.9999ZM22.9001 13.0999C22.2001 12.3999 21.1001 12.3999 20.5001 13.0999L18.6001 14.9999H14.1001C13.2001 14.9999 12.4001 15.7999 12.4001 16.6999V22.6999C12.4001 22.9999 12.6001 23.1999 12.9001 23.1999C13.2001 23.1999 13.4001 22.9999 13.4001 22.6999V16.6999C13.4001 16.2999 13.7001 15.9999 14.1001 15.9999H18.8001C18.9001 15.9999 19.1001 15.8999 19.2001 15.8999L21.2001 13.8999C21.5001 13.5999 21.9001 13.5999 22.2001 13.8999C22.3001 13.9999 22.4001 14.1999 22.4001 14.3999C22.4001 14.5999 22.3001 14.7999 22.2001 14.8999L19.8001 17.2999C19.7001 17.3999 19.5001 17.4998 19.3001 17.4998H15.3001C15.0001 17.4998 14.8001 17.6998 14.8001 17.9998V22.7998C14.8001 23.0998 15.0001 23.2998 15.3001 23.2998C15.6001 23.2998 15.8001 23.0998 15.8001 22.7998V18.4998H19.3001C19.8001 18.4998 20.2001 18.2998 20.5001 17.9998L22.9001 15.5998C23.2001 15.2998 23.4001 14.7998 23.4001 14.3998C23.4001 13.7998 23.2001 13.3998 22.9001 13.0998L22.9001 13.0999ZM10.4001 7.19989C11.2001 7.19989 11.8001 6.59989 11.8001 5.79989C11.8001 4.9999 11.2001 4.3999 10.4001 4.3999C9.6001 4.3999 9.0001 4.9999 9.0001 5.79989C9.0001 6.59989 9.6001 7.19989 10.4001 7.19989ZM10.4001 5.39989C10.6001 5.39989 10.8001 5.59988 10.8001 5.79989C10.8001 5.99991 10.6001 6.1999 10.4001 6.1999C10.1001 6.1999 10.0001 5.99991 10.0001 5.79989C10.0001 5.59988 10.1001 5.39989 10.4001 5.39989ZM12.3001 8.69989C12.3001 9.49988 12.9001 10.0999 13.7001 10.0999C14.5001 10.0999 15.1001 9.49988 15.1001 8.69989C15.1001 7.89989 14.5001 7.29989 13.7001 7.29989C12.9001 7.29989 12.3001 7.89989 12.3001 8.69989ZM14.2001 8.69989C14.2001 8.89988 14.0001 9.09989 13.8001 9.09989C13.6001 9.09989 13.4001 8.8999 13.4001 8.69989C13.4001 8.4999 13.6001 8.29988 13.8001 8.29988C14.0001 8.29988 14.2001 8.49987 14.2001 8.69989ZM9.80009 9.89989C9.9001 9.99989 10.0001 9.99989 10.1001 9.99989C10.2001 9.99989 10.4001 9.89989 10.5001 9.7999L14.2001 5.8999C14.4001 5.69991 14.4001 5.39991 14.2001 5.19989C14.0001 4.99988 13.7001 4.9999 13.5001 5.2999L9.80009 9.09989C9.6001 9.29989 9.6001 9.69989 9.80009 9.89989Z" fill="currentColor" />
                      <path d="M8.09981 14.3H16.2998C17.7998 14.3 19.0998 13 19.0998 11.5V3.30001C19.0998 1.80001 17.7998 0.5 16.2998 0.5H8.09981C6.59981 0.5 5.2998 1.80001 5.2998 3.30001V11.5C5.2998 13.1 6.59981 14.3 8.09981 14.3ZM6.29981 3.30003C6.29981 2.30002 7.0998 1.50003 8.09981 1.50003H16.2998C17.2998 1.50003 18.0998 2.30002 18.0998 3.30003V11.5C18.0998 12.5 17.2998 13.3 16.2998 13.3H8.09981C7.0998 13.3 6.29981 12.5 6.29981 11.5V3.30003Z" fill="currentColor" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_51">
                        <rect width="24" height="24" fill="currentColor" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div>
                  Stock Management
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showStockManagementDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("stockitems")
                  ) && (
                    <li>
                  <NavLink
                    to="/stocks/dashboard"
                    className="sideMenu-item"
                  >
                    <div className="sideMenu-dropCircle"></div>
                    Dashboard
                  </NavLink>
                </li>
                  )
                }
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("stockitems")
                  ) && (
                    <li>
                      <NavLink
                        to="/stockitems"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Stock Items
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("materialissues")
                  )
                  && (
                    <li>
                      <NavLink to="/materialissues" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Material Issue Slips
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("materialreceiptslips")
                  )
                  && (
                    <li>
                      <NavLink to="/materialreceiptslips" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Material Receipt Slips
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("stockcategory")
                  )
                  && (
                    <li>
                      <NavLink to="/stockcategories" className="sideMenu-item">
                        <div className="sideMenu-dropCircle"></div>
                        Stock Categories
                      </NavLink>
                    </li>
                  )
                }

              </ul>
            )
          }

          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("employees")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'reportsDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowReportsDrop(prev => !prev)}
              >
                <div>
                  <BsPieChart />
                </div>
                <div>
                  Reports
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showReportsDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employees")
                  ) && (
                    <li>
                      <NavLink
                        to="/employee-report"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Employee
                      </NavLink>
                    </li>
                  )
                }

              </ul>
            )
          }
 {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("employees")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'accountsDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowAccountsDrop(prev => !prev)}
              >
                <div>
                  <BsPieChart />
                </div>
                <div>
                  Accounts
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }
 {
            showAccountsDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("employees")
                  ) && (
                    <li>
                      <NavLink
                        to="/accounts"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Accounts
                      </NavLink>
                    </li>
                  )
                }

              </ul>
            )
          }
          {
            (
              userData.doc.isSuperAdmin ||
              userData.doc.isAdmin ||
              userData.role.read.includes("workinghours")
            )
            && (
              <div
                className={`sideMenu-heading flex items-center gap-x-2 ${activeSection === 'settingsDrop' ? 'sideMenuActiveSection' : ''}`}
                onClick={() => setShowSettingsDrop(prev => !prev)}
              >
                <div>
                  <BsGear />
                </div>
                <div>
                  Settings
                </div>
                <div>
                  <BsArrowDownShort />
                </div>
              </div>
            )
          }

          {
            showSettingsDrop && (
              <ul className="sideMenu-dropList">
                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin ||
                    userData.role.read.includes("workinghours")
                  ) && (
                    <li>
                      <NavLink
                        to="/working-hours"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Office Timings
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin ||
                    userData.doc.isAdmin
                  ) && (
                    <li>
                      <NavLink
                        to="/roles"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Roles
                      </NavLink>
                    </li>
                  )
                }

                {
                  (
                    userData.doc.isSuperAdmin
                  ) && (
                    <li>
                      <NavLink
                        to="/admins"
                        className="sideMenu-item"
                      >
                        <div className="sideMenu-dropCircle"></div>
                        Admins
                      </NavLink>
                    </li>
                  )
                }

              </ul>
            )
          }




        </div>
        <div className="ps-[35px] mt-[30px]">
          <button className="btn-primary p-sm font-semibold" onClick={handleLogOutButton}>Log Out</button>
        </div>


      </div>

    </aside>
  );
};

export default Sidebar;
